"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const SearchResult_1 = __importDefault(require("./SearchResult"));
function empty() {
    return react_1.default.createElement("i", null, "Search results will show up here");
}
function allResults(nodes) {
    const title = `Results: ${nodes.length}`;
    return react_1.default.createElement("div", null,
        react_1.default.createElement("h2", { className: "title is-4" }, title),
        react_1.default.createElement("pre", null, nodes.map((node, i) => react_1.default.createElement(SearchResult_1.default, { node: node, key: i }))));
}
function Results({ nodes }) {
    return react_1.default.createElement("div", { className: "container" }, nodes.length > 0 ? allResults(nodes) : empty());
}
exports.default = Results;
